import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, useTheme, Box, Typography } from "@mui/material";
import ProTextInput from "../../../Components/Inputs/TextField";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ConfirmationModal from "../../ConfirmationModal";
import PropTypes from "prop-types";

export default function EditCell({ params, onEdit, disabled = false }) {
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);
  
  const { control, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      noteTitle: "",
      note: ""
    }
  });

  const dummyRules = {};
  const dummyPermission = { canView: true, canEdit: true };

  const noteValue = watch("note") || "";

  const openModal = (event) => {
    event.stopPropagation();
    if (disabled) return;
    reset({
      noteTitle: params.row?.noteTitle || "",
      note: params.row?.notes || ""
    });
    setShowModal(true);
  };
  
  const handleEdit = handleSubmit((formData) => {
    onEdit({ 
      ...params.row, 
      noteTitle: formData.noteTitle, 
      notes: formData.note 
    });
    setShowModal(false);
  });

  return (
    <>
      <Button
        className="proGrid-edit"
        variant="outlined"
        size="small"
        onClick={openModal}
        disabled={disabled}
        sx={{
          border: theme.palette.progrid.cellbuttonborder,
          backgroundColor: theme.palette.progrid.cellbuttonbackgroundcolor,
          color: theme.palette.progrid.cellbuttoncolor,
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: 0,
          marginRight: 1,
          '&:hover': {
            backgroundColor: disabled ? theme.palette.progrid.cellbuttonbackgroundcolor : theme.palette.progrid.cellbuttonhoverbackgroundcolor
          }
        }}
      >
        <EditOutlinedIcon fontSize="small" sx={{ color: "#000" }} />
      </Button>
      {showModal && (
        <ConfirmationModal
          show={showModal}
          title="Edit Note"
          message={
            <Box display="flex" flexDirection="column" gap={2}>
              <ProTextInput
                name="noteTitle"
                label="Title"
                control={control}
                rules={dummyRules}
                mode="edit"
                permission={dummyPermission}
                fullWidth
                autoFocus
              />
              <Box>
                <ProTextInput
                  name="note"
                  label="Note"
                  control={control}
                  rules={{ maxLength: { value: 500, message: "Note cannot exceed 500 characters." }}}
                  mode="edit"
                  permission={dummyPermission}
                  fullWidth
                  multiline
                  minRows={4}
                />
                <Typography 
                  variant="caption" 
                  color="text.secondary" 
                  sx={{ mt: 0.5, display: 'block', textAlign: 'right' }}
                >
                  {noteValue.length}/500 characters
                </Typography>
              </Box>
            </Box>
          }
          onConfirm={handleEdit}
          onCancel={() => setShowModal(false)}
          confirmBtnText="Save"
          dialogProps={{
            maxWidth: "md",
            sx: { "& .MuiDialog-paper": { width: "1000px", maxWidth: "90vw" } }
          }}
        />
      )}
    </>
  );
}

EditCell.propTypes = {
  params: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};